import React, { useContext, useEffect, useState } from 'react'

//imagenes
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import usuariosIcon from "../assets/img/usuarios.svg";
import ConexContext from '../context/ConexContext';
import { useNavigate } from 'react-router-dom';
import { formatFecha } from './JS/formato';
import { ReactComponent as ArrowDown } from "../assets/img/arrowtable.svg";
import { ReactComponent as IconTrash } from "../assets/img/icon-trash.svg";
import { ReactComponent as IconEdit } from "../assets/img/icon-edit.svg";
import ModalGenericoUsuario from './modales/ModalGenericoUsuario';

const Usuarios = () => {
	const { peticion, tipo_usuario, id_usuario } = useContext(ConexContext);
	const navigate = useNavigate();
	const [datosUsu, setDatosUsu] = useState(null); //datos de los usuarios
	const [orden, setOrden] = useState({
		campo: 'cod_usuario',
		orden: 'asc'
	}); //orden de la tabla

	const [mensaje, setMensaje] = useState(null); //mensaje de error
	const [modalEliminar, setModalEliminar] = useState(false); //modal eliminar usuario
	const [usuarioEliminar, setUsuarioEliminar] = useState(null); //usuario a eliminar

	const [filtros, setFiltros] = useState({ //filtros
		entidad: '',
		empresa: '',
		buscar: ''
	});
	const [entidades, setEntidades] = useState({}); //listado de entidades con las empresas

	/**
	 * Carga los datos de los usuarios
	 */
	useEffect(() => {
		const listado_usuarios = async () => {
			let res = await peticion(`/listado_usuarios`, { method: 'GET' });
			if (res?.estado ?? true) return;
			if (res?.res ?? false) {
				setDatosUsu(res["res"]);
				//obtener entidades y empresas para filtrar
				const entidadesObj = {};
				res["res"].forEach(usuario => {
					const entidadCod = usuario.cod_ent;
					const entidadNombre = usuario.nombre_ent;
					const empresaNombre = usuario.nombre_emp;

					if (!entidadesObj[entidadCod]) {
							entidadesObj[entidadCod] = {
									cod: entidadCod,
									nombre: entidadNombre,
									empresas: []
							};
					}
					if (!entidadesObj[entidadCod].empresas.includes(empresaNombre))
						entidadesObj[entidadCod].empresas.push(empresaNombre);
				});
				setEntidades(entidadesObj);
			}
		}

		if (tipo_usuario === '5' || tipo_usuario === '2' || tipo_usuario === '0' || tipo_usuario === '3')
			listado_usuarios();
	}, [tipo_usuario, peticion]);

	/**
	 * Ordena la tabla
	 * @param {String} campo campo por el que se ordena
	 */
	const ordenar = (campo) => {
		if (orden.campo === campo) {
			setOrden({
				campo: campo,
				orden: orden.orden === 'asc' ? 'desc' : 'asc'
			});
		} else {
			setOrden({
				campo: campo,
				orden: 'asc'
			});
		}
	}

	/**
	 * Elimina un usuario
	 * @returns 0 si todo ha ido bien, otra cosa si ha habido algún error
	 */
	const eliminarUsu = async () => {
		const res = await peticion(`/eliminar_usuario`, {
			method: "POST",
			json: { usuario: usuarioEliminar },
		});
		if (res?.estado ?? true) return setMensaje("Se ha producido un error. " + res.mensaje); //error
		if (res?.mensaje !== "OK" ?? false)
			return setMensaje(
				res?.mensaje ??
					"Error al eliminar el usuario " + usuarioEliminar + ""
			); //errores
		setUsuarioEliminar(null);
		return 0;
	};

	return (
		<>
			<div className="col-xs-12 tabla" id='user-mng' >
				<div className='section-header'>
					<div className='img-container'>
						<img src={usuariosIcon} alt=''></img>
					</div>
					<div>
						<h2>Gestión de usuarios</h2>
						<h6><strong>Listado</strong></h6>
					</div>
				</div>
				<main>
				<h3>Filtrar por:</h3>
				<div className="filtering__container">
					<div className="filtering">
						<select id="entidad" name="entidad"
							onChange={(e) => setFiltros({ ...filtros, entidad: e.target.value, empresa: ''})}
						>
							<option value="">Selecciona una entidad</option>
							{
								Object.keys(entidades).map((entidadCod, index) => (
									<option key={index} value={entidadCod}>{entidades[entidadCod].nombre}</option>
								))

							}
						</select>
					</div>
					<div className="filtering">
						<select id="tipo-usuario" name="tipo-usuario"
							onChange={(e) => setFiltros({ ...filtros, empresa: e.target.value })}
							disabled={filtros.entidad === ''}
						>
							<option value="">Selecciona una empresa</option>
							{
								Object.keys(entidades)
									.filter(entidadCod => entidades[entidadCod].cod === filtros.entidad)
									.map((entidadCod, index) => (
										entidades[entidadCod].empresas.map((empresa, index) => (
											<option key={index} value={empresa}>{empresa}</option>
										))
									))
							}
						</select>
					</div>
					<div className='filtering'>
						<input 
							type='text' 
							placeholder='Buscar...' 
							onChange={(e) => setFiltros({ ...filtros, buscar: e.target.value })}
						/>
					</div>
				</div>

					<div className="col-xs-12 cabeceratabla">
						<div className="col-xs-12 cont_cabeceratabla">
							<table>
								<tbody>
									<tr>
										<td 
											onClick={() => ordenar('cod_usuario')}
											className={orden.campo === 'cod_usuario' ? `order-${orden.orden}` : ''}
										>
											Código de usuario
											{orden.campo === 'cod_usuario' && <ArrowDown />}
										</td>
										<td 
											onClick={() => ordenar('nombre_usuario')}
											className={orden.campo === 'nombre_usuario' ? `order-${orden.orden}` : ''}
										>
											Nombre
											{orden.campo === 'nombre_usuario' && <ArrowDown />}
										</td>
										<td 
											onClick={() => ordenar('email')}
											className={orden.campo === 'email' ? `order-${orden.orden}` : ''}
										>
											Email
											{orden.campo === 'email' && <ArrowDown />}
										</td>
										<td 
											onClick={() => ordenar('nombre_ent')}
											className={orden.campo === 'nombre_ent' ? `order-${orden.orden}` : ''}
										>
											Entidad
											{orden.campo === 'nombre_ent' && <ArrowDown />}
										</td>
										<td 
											onClick={() => ordenar('nombre_emp')}
											className={orden.campo === 'nombre_emp' ? `order-${orden.orden}` : ''}
										>
											Empresa
											{orden.campo === 'nombre_emp' && <ArrowDown />}
										</td>
										<td 
											onClick={() => ordenar('nombre_dpto')}
											className={orden.campo === 'nombre_dpto' ? `order-${orden.orden}` : ''}
										>
											Departamento
											{orden.campo === 'nombre_dpto' && <ArrowDown />}
										</td>
										<td 
											onClick={() => ordenar('tipo_usuario')}
											className={orden.campo === 'tipo_usuario' ? `order-${orden.orden}` : ''}
										>
											Tipo de usuario
											{orden.campo === 'tipo_usuario' && <ArrowDown />}
										</td>
										<td 
											onClick={() => ordenar('fecha_alta_usu')}
											className={orden.campo === 'fecha_alta_usu' ? `order-${orden.orden}` : ''}
										>
											Fecha de alta
											{orden.campo === 'fecha_alta_usu' && <ArrowDown />}
										</td>
										<td 
											onClick={() => ordenar('nif_usuario')}
											className={orden.campo === 'nif_usuario' ? `order-${orden.orden}` : ''}
										>
											NIF
											{orden.campo === 'nif_usuario' && <ArrowDown />}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					
					<div className='tabladatos'>
						<div className="col-xs-12 cont_tabladatos">
					
							{!datosUsu ?
								<h1 className="cargando">Cargando...</h1>
								:
								<table>
									<tbody>
										{
											datosUsu
												.filter(usuario => { //filtrar por entidad y empresa
													if (filtros.entidad !== '' && usuario.cod_ent !== filtros.entidad) return false;
													if (filtros.empresa !== '' && usuario.nombre_emp !== filtros.empresa) return false;
													return true;
												})
												.filter(usuario => { //filtrar por búsqueda en nombre, email, entidad, empresa, departamento, código de usuario y nif
													if (filtros.buscar !== '' && 
														(
															!usuario.nombre_usuario.toLowerCase().includes(filtros.buscar.toLowerCase()) &&
															!usuario.email.toLowerCase().includes(filtros.buscar.toLowerCase()) &&
															!usuario.nombre_ent.toLowerCase().includes(filtros.buscar.toLowerCase()) &&
															!usuario.nombre_emp.toLowerCase().includes(filtros.buscar.toLowerCase()) &&
															!usuario.nombre_dpto.toLowerCase().includes(filtros.buscar.toLowerCase()) && 
															!usuario.cod_usuario.toLowerCase().includes(filtros.buscar.toLowerCase()) &&
															!usuario.nif_usuario.toLowerCase().includes(filtros.buscar.toLowerCase())
														)
													) return false;
													return true;
												})
												.sort((a, b) => {
													if (orden.orden === 'asc') {
														if (a[orden.campo] > b[orden.campo]) return 1;
														if (a[orden.campo] < b[orden.campo]) return -1;
														return 0;
													} else {
														if (a[orden.campo] < b[orden.campo]) return 1;
														if (a[orden.campo] > b[orden.campo]) return -1;
														return 0;
													}
												})
												.map((usuario, index) => (
					
													<tr key={index}>
														<td>
															<div>
																{usuario.cod_usuario} {usuario.cod_usuario === id_usuario ? '(Usuario actual)' : ''}
															</div>
														</td>
														<td>
															<div>
																{usuario.nombre_usuario}
															</div>
														</td>
														<td>
															<div>
																{usuario.email}
															</div>
														</td>
														<td>
															<div>
																{usuario.nombre_ent}
															</div>
														</td>
														<td>
															<div>
																{usuario.nombre_emp}
															</div>
														</td>
														<td>
															<div>
																{usuario.nombre_dpto}
															</div>
														</td>
														<td>
															<div>
																{usuario.tipo_usuario === '0' ? 'Entidad' : usuario.tipo_usuario === '1' ? 'Usuario' : usuario.tipo_usuario === '2' ? 'Departamento' : usuario.tipo_usuario === '3' ? 'Empresa' : usuario.tipo_usuario === '5' ? 'Administrador' : 'Desconocido'}
															</div>
														</td>
														<td>
															<div>
																{formatFecha(usuario.fecha_alta_usu, "ISO8601", "esp")}
															</div>
														</td>
														<td>
															<div>
																{usuario.nif_usuario}
															</div>
															<div className="icon-container">
																<div>
																	<IconEdit
																		alt="Editar"
																		onClick={() => navigate('/perfil/' + usuario.cod_usuario)}
																	/>
																</div>
																<div>
																	<IconTrash
																		alt="Eliminar"
																		onClick={() => {
																			setUsuarioEliminar(usuario.cod_usuario);
																			setModalEliminar(true);
																		}}
																	/>
																</div>
															</div>
														</td>
													</tr>
												))
										}
									</tbody>
								</table>
							}
						</div>
					</div>
					{tipo_usuario === '5' &&
						<div className='button-container'>
							<button className='cta' onClick={() => navigate('/perfil/')}>Crear usuario</button>
						</div>
					}
				</main>
			</div >
			{/* 
				Modal de confirmación de eliminación de usuario
			*/}
			<ModalGenericoUsuario
				texto1={"¿Quiere eliminar este usuario?"}
				texto2={"Usuario eliminado correctamente"}
				mensaje={mensaje}
				texto3={"Eliminar usuario"}
				setMensaje={setMensaje}
				navegar={() => navigate("/administracion/")}
				navegarError={() => navigate("/perfil/" + datosUsu.cod_usuario)}
				show={modalEliminar}
				onHide={() => setModalEliminar(false)}
				func={eliminarUsu}
			/>
		</>
	)
}

export default Usuarios;